import { render, staticRenderFns } from "./ChangeActive.vue?vue&type=template&id=0664f548&scoped=true"
import script from "./ChangeActive.vue?vue&type=script&lang=js"
export * from "./ChangeActive.vue?vue&type=script&lang=js"
import style0 from "./ChangeActive.vue?vue&type=style&index=0&id=0664f548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0664f548",
  null
  
)

export default component.exports